﻿import axios from 'src/api/axiosConfig'
import type { ApiResponse } from 'src/types/apiTypes'
import type { LoginRequest, MagicLinkLoginRequest } from 'src/types/webContracts'
import type { AxiosResponse } from 'axios'
import { ApiRoutes } from '../ApiRoutes'
import type { AppDownloadResult } from '@/types/storeTypes'

export async function postLogin(model: LoginRequest): Promise<AxiosResponse<ApiResponse<boolean>>> {
  const response = await axios.post(ApiRoutes.Login.LoginPost, model)
  return response;
}

export async function postMagicLinkLogin(model: MagicLinkLoginRequest): Promise<AxiosResponse<ApiResponse<number>>> {
  const response = await axios.post(ApiRoutes.Login.LoginPost, model)
  return response;
}

export async function postLoginWithExisting(model: LoginRequest): Promise<AxiosResponse<ApiResponse<boolean>>> {
  const response = await axios.post(ApiRoutes.Login.LoginWithExistingPost, model)
  return response;
}

export async function logout(): Promise<AxiosResponse<ApiResponse<boolean>>> {
  const response = await axios.post(ApiRoutes.Login.LogOutPost)
  return response;
}

export async function getMedStratSigningUrl(): Promise<AxiosResponse<ApiResponse<string>>> {
  const response = await axios.get(ApiRoutes.Login.GetMedStratSigningUrl)
  return response;
}

export async function getCobrandingStyles(): Promise<AxiosResponse<ApiResponse<string>>> {
  const response = await axios.get(ApiRoutes.Login.GetClientStyleCss)
  return response;
}

export async function getCustomerSupportInfo(countryCode: string ,locale: string): Promise<AxiosResponse<ApiResponse<AppDownloadResult>>> {
  const response = await axios.get<ApiResponse<AppDownloadResult>>(ApiRoutes.Login.GetCustomerSupportInfo, { params: { countryCode, locale } })
  return response;
}

export async function getHasPasscode(): Promise<AxiosResponse<ApiResponse<boolean>>> {
  const response = await axios.get(ApiRoutes.Login.GetHasPasscode)
  return response;
}
